"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var locale = {
  placeholder: 'Select time',
  rangePlaceholder: ['Start time', 'End time']
};
var _default = locale;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/time-picker/locale/en_US.js
// module id = 222
// module chunks = 0